<template>
  <section>
    <p v-if="error" class="text-danger" role="alert">{{ error }} <button class="btn btn-sm btn-default" @click="load">Retry</button></p>
    <p v-if="loading">Loading contracts…</p>
    <template v-else-if="loaded">
      <p v-if="!files.length">No contracts uploaded.</p>
      <table v-else class="table">
        <thead><tr><th>File</th><th>Created</th><th>Comment</th><th v-if="canManageAgencies">Actions</th></tr></thead>
        <tbody><tr v-for="file in files" :key="file.id">
          <td><button class="btn btn-link" :disabled="busy || !file.object_key" @click="download(file)">{{ file.filename }}</button><small v-if="!file.object_key">Not available in AWS</small></td>
          <td>{{ date(file.created_at) }}</td>
          <td>{{ file.comment }}</td>
          <td v-if="canManageAgencies"><button class="btn btn-sm btn-default" :disabled="busy" @click="edit(file)">Edit comment</button> <button class="btn btn-sm btn-danger" :disabled="busy" @click="remove(file)">Remove</button></td>
        </tr></tbody>
      </table>
      <template v-if="canManageAgencies">
      <label class="d-block">Add contracts — PDF, DOC/DOCX, JPG/PNG, ZIP; up to 10 files, 50 MB total
        <input ref="input" type="file" accept=".pdf,.doc,.docx,.jpg,.jpeg,.png,.zip" multiple :disabled="busy" @change="select" />
      </label>
      <label class="d-block">Comment <el-input v-model="comment" type="textarea" :disabled="busy" maxlength="65535" /></label>
      <button class="btn btn-primary" :disabled="busy || !pending.length" @click="upload">{{ busy ? 'Saving…' : 'Upload contracts' }}</button>
      </template>
    </template>
  </section>
</template>
<script>
import agencyAccess from '@/components/Agencies/agencyAccess';
import API from '@/api/modules/agencies';
export default {
  mixins: [agencyAccess],
  props: { agencyId: { type: [String, Number], required: true } },
  data: () => ({ files: [], pending: [], comment: '', error: '', busy: false, loading: false, loaded: false }),
  created() { this.load(); },
  watch: { agencyId() { this.pending = []; this.comment = ''; this.load(); } },
  methods: {
    date(value) { return new Date(Number(value) * 1000).toISOString().slice(0, 10); },
    select(event) {
      if (!this.canManageAgencies) return; this.pending = Array.from(event.target.files || []); },
    async load() {
      const id = this.agencyId; this.loading = true; this.loaded = false; this.error = '';
      try { const files = await API.getContracts(id); if (id === this.agencyId) { this.files = files; this.loaded = true; } }
      catch (e) { this.error = 'Could not load contracts.'; }
      finally { this.loading = false; }
    },
    async run(action) {
      if (!this.canManageAgencies) return;
      this.busy = true; this.error = '';
      try { await action(); await this.load(); }
      catch (e) { this.error = 'Contract operation failed. Reload the list before retrying.'; }
      finally { this.busy = false; }
    },
    async upload() {
      if (!this.canManageAgencies) return;
      if (this.pending.length > 10 || this.pending.some(file => !file.size) || this.pending.reduce((total,file) => total + file.size,0) > 50 * 1024 * 1024) { this.error = 'Upload 1 to 10 files, up to 50 MB total.'; return; }
      await this.run(async () => { await API.uploadContracts(this.agencyId, this.pending, this.comment); this.pending = []; this.comment = ''; this.$refs.input.value = ''; });
    },
    async download(file) {
      // Open during the click to avoid popup blocking; the URL is generated only after admin authorization.
      const target = window.open('about:blank', '_blank');
      try { const url = await API.downloadContract(this.agencyId, file.id); if (target) { target.opener = null; target.location = url; } else window.location.assign(url); }
      catch (e) { if (target) target.close(); this.error = 'Could not download contract.'; }
    },
    async edit(file) {
      if (!this.canManageAgencies) return;
      try { const result = await this.$prompt('Contract comment', 'Edit comment', { inputValue: file.comment }); await this.run(() => API.editContract(this.agencyId, file.id, result.value || '')); }
      catch (e) { /* Cancel preserves the comment. */ }
    },
    async remove(file) {
      if (!this.canManageAgencies) return;
      try { await this.$confirm('Remove this contract from the partner?', 'Remove contract', { type: 'warning' }); await this.run(() => API.removeContract(this.agencyId, file.id)); }
      catch (e) { /* Cancel preserves the contract. */ }
    },
  },
};
</script>
